import head from "lodash/head"
import filter from "lodash/filter"
import get from "lodash/get"
import { ItemList } from '../orm'

class AlbumList extends ItemList {

  getEntityKey() {
    return "customer/album"
  }

  getAlbumForAlbumName(album_name) {
    const albums = this.getVisibleObjects()
    return head(filter(albums, (x) => x.name === album_name))
  }

  getIdForAlbumName(album_name) {
    const album = this.getAlbumForAlbumName(album_name)
    return get(album, ["id"])
  }

  getGalleryEventIdForAlbumName(album_name) {
    const album = this.getAlbumForAlbumName(album_name)
    return get(album, ["gallery_event_id"])
  }
}

export const albumList = new AlbumList("album_default")
export const albumListForEventTab = new AlbumList("album_for_event_tab_default")
